import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id      : 0,
        project_id      : 0,
        email_subject   : '',
        email_html      : '',
        feedback_type   : '',
        is_disabled     : false
    }
});